import { render, staticRenderFns } from "./gift-cards.component.vue?vue&type=template&id=33a3770c&"
import script from "./gift-cards.component.vue?vue&type=script&lang=js&"
export * from "./gift-cards.component.vue?vue&type=script&lang=js&"
import style0 from "./gift-cards.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports